import React, { FC } from 'react';
import { useHistory } from 'react-router';

import Header from '../../../../../../components/Layouts/MyPage/Header/MyPageHeader.index';
import Footer from '../../../../../../components/Layouts/MyPage/Footer/MyPageFooter.index';

const ReservationCancelComplete: FC = () => {
  const history = useHistory();

  const onClickShopSelect = () => {
    history.push('/');
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />

        <div className="reservation-cancel-complete" style={{ flex: '1' }}>
          <main className="main-layout l-main">
            <section className="p-title-area">
              <p className="c-title">
                予約のキャンセルが
                <br className="u-sp-only" />
                完了しました
              </p>
            </section>
            <section className="p-content-area u-gap50">
              <div className="p-content-area__column u-gap0 u-sp-gap7">
                {/* <!-- テキスト --> */}
                <p className="c-read">
                  MIRA fitnessの体験・見学予約のキャンセルが完了しました。
                  <br />
                  ご登録のメールアドレス宛に、キャンセル完了のお知らせをお送りしております。
                  <br />
                  またのご利用をお待ちしております。
                </p>
              </div>
            </section>
            <section className="p-button-area">
              {/* <!-- ボタン --> */}
              <button
                type="button"
                className="c-button c-button--secondary c-button--large"
                onClick={onClickShopSelect}
              >
                店舗選択へ戻る
              </button>
            </section>
          </main>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ReservationCancelComplete;
